module.exports = __webpack_public_path__ + "static/media/Brenna Sadler Headshot_1691070568709.6cf0daf5.jpeg";